<script>
export default {
  data() {
    const CODES = {
      YES_OR_NO: [
        {
          text: '예',
          value: true,
          label: 'label-primary'
        },
        {
          text: '아니오',
          value: false,
          label: 'label-primary'
        }
      ],
      PRODUCT_UI_TYPE: [
        {
          text: 'PROJECT',
          value: 'PROJECT',
          label: 'label-primary'
        },
        {
          text: 'ORG',
          value: 'ORG',
          label: 'label-danger'
        }
      ],
      WIDGET_TYPE: [
        {
          text: 'SUB_MENU',
          value: 'SUB_MENU',
          label: 'label-primary'
        },
        {
          text: 'SUB_MENU_LABEL',
          value: 'SUB_MENU_LABEL',
          label: 'label-primary'
        },
        {
          text: 'LABEL',
          value: 'LABEL',
          label: 'label-danger'
        },
        {
          text: 'BUTTON',
          value: 'BUTTON',
          label: 'label-info'
        }
      ],
      SOLUSION_TYPE: [
        {
          value: 'finance',
          hide: ['JP'],
          messageId: {
            name: 'solution.finance.name',
            nameForLnb: 'solution.finance.name'
          }
        },
        {
          value: 'commerce',
          hide: ['JP'],
          messageId: {
            name: 'solution.commerce.name',
            nameForLnb: 'solution.commerce.name'
          }
        },
        {
          value: 'game',
          messageId: {
            name: 'solution.game.name',
            nameForLnb: 'solution.game.name'
          }
        }
      ],
      REGION_ORDER_TYPE: {
        KR: ['KR1', 'KR2', 'JP1', 'US1'],
        JP: ['JP1', 'KR1', 'KR2', 'US1']
      },
      PRICING_TYPE: [
        {
          value: 'by-region',
          messageId: {
            name: 'pricing.by-region.name',
            nameForLnb: 'pricing.by-region.name'
          }
        },
        {
          value: 'by-service',
          messageId: {
            name: 'pricing.by-service.name',
            nameForLnb: 'pricing.by-service.name'
          }
        },
        {
          value: 'calculator',
          messageId: {
            name: 'pricing.calculator.name',
            nameForLnb: 'pricing.calculator.name'
          }
        }
      ],
      CUSTOMER_STORY_CATEGORY_TYPE: (() => {
        const FINANCE_OR_PUBLIC = {
          value: 'FINANCE_OR_PUBLIC',
          messageId: {
            name: 'customer-story.finance-or-public.name',
            nameForLnb: 'customer-story.finance-or-public.lnb.name',
            intro: 'customer-story.finance-or-public.intro',
            Section: 'main.reference.finance-or-public'
          }
        }
        const GENERAL = {
          value: 'GENERAL',
          messageId: {
            name: 'customer-story.general.name',
            nameForLnb: 'customer-story.general.lnb.name',
            intro: 'customer-story.general.intro',
            Section: 'main.reference.general'
          }
        }
        const COMMERCE = {
          value: 'COMMERCE',
          messageId: {
            name: 'customer-story.commerce.name',
            nameForLnb: 'customer-story.commerce.lnb.name',
            intro: 'customer-story.commerce.intro',
            Section: 'main.reference.commerce'
          }
        }
        const GAME = {
          value: 'GAME',
          messageId: {
            name: 'customer-story.game.name',
            nameForLnb: 'customer-story.game.lnb.name',
            intro: 'customer-story.game.intro',
            Section: 'main.reference.game'
          }
        }

        return {
          KR: [FINANCE_OR_PUBLIC, GENERAL, COMMERCE, GAME],
          JP: [GAME, GENERAL, COMMERCE, FINANCE_OR_PUBLIC]
        }
      })(),
      TERMS_TYPE: [
        {
          text: '약관',
          value: 'TERMS_SERVICE',
          label: 'badge-warning'
        },
        {
          text: '서비스 수준 계약',
          value: 'TERMS_SLA',
          label: 'badge-warning'
        },
        {
          text: '파트너 약관',
          value: 'TERMS_PARTNER',
          label: 'badge-warning'
        },
        {
          text: '개인정보 처리방침',
          value: 'PRIVACY_POLICY',
          label: 'badge-warning'
        },
        {
          text: '개인정보 수집 및 동의',
          value: 'COLLECTION_AND_USE_AGREE_SERVICE',
          label: 'badge-warning'
        },
        {
          text: '개인정보 수집 및 동의(파트너)',
          value: 'COLLECTION_AND_USE_AGREE_PARTNER',
          label: 'badge-warning'
        },
        {
          text: '개인정보 제3자 제공 동의(파트너)',
          value: 'PROVIDE_THIRD_PARTY_AGREE',
          label: 'badge-warning'
        },
        {
          text: '광고성 정보 수신 및 개인정보 마케팅 활용 동의(파트너)',
          value: 'TERMS_PARTNER_ADVERTISING',
          label: 'badge-warning'
        },
        {
          text: '지원 정책',
          value: 'SUPPORT_POLICY',
          label: 'badge-warning'
        },
        {
          text: '특정상법 거래에 관한 법률에 의거한 표기',
          value: 'COMMERCIAL_LAW',
          label: 'badge-warning'
        },
        {
          text: '마켓플레이스 개인정보 수집 이용 동의',
          value: 'MARKETPLACE_PRIVACY_POLICY',
          label: 'badge-warning'
        },
        {
          text: '마켓플레이스 개인정보 제3자 제공 동의창(토스트→제공사)',
          value: 'MP_COLLECTION_AND_USE_AGREE_SERVICE',
          label: 'badge-warning'
        },
        {
          text: '마켓플레이스 개인정보 제3자 제공 동의창(제공사→토스트)',
          value: 'MP_COLLECTION_AND_USE_AGREE_PARTNER',
          label: 'badge-warning'
        },
        {
          text: '개인정보 제3자 제공 동의(Dooray)', //'Dooray 개인정보 3자 제공 동의',
          value: 'DOORAY_PROVIDE_THIRD_PARTY_AGREE',
          label: 'badge-warning'
        },
        {
          text: '공공 클라우드 개인정보 마케팅 활용 및 광고성 정보 수신 동의 (선택)', //'공공 클라우드 개인정보 마케팅 활용 및 광고성 정보 수신 동의 (선택)',
          value: 'MARKETING_CONSENT_GOV',
          label: 'badge-warning'
        },
        {
          text: '퍼블릭 클라우드(개인) 개인정보 마케팅 활용 및 광고성 정보 수신 동의 (선택)', //'퍼블릭 클라우드(개인) 개인정보 마케팅 활용 및 광고성 정보 수신 동의 (선택)',
          value: 'MARKETING_CONSENT_INDIVIDUAL',
          label: 'badge-warning'
        },
        {
          text: '퍼블릭 클라우드(사업자) 개인정보 마케팅 활용 및 광고성 정보 수신 동의 (선택)', //'퍼블릭 클라우드(사업자) 개인정보 마케팅 활용 및 광고성 정보 수신 동의 (선택)',
          value: 'MARKETING_CONSENT_BUSINESS',
          label: 'badge-warning'
        }
      ],
      PARTNER_CENTER_CUSTOMER_TYPE: [
        {
          text: 'partner.popup.join.staff.info.consumer.public',
          value: 'PUBLIC_INSTITUTIONS'
        },
        {
          text: 'partner.popup.join.staff.info.consumer.business',
          value: 'ENTERPRISE'
        },
        {
          text: 'partner.popup.join.staff.info.consumer.personal',
          value: 'INDIVIDUAL'
        },
        {
          text: 'partner.popup.join.staff.info.consumer.others',
          value: 'ETC'
        }
      ],
      PARTNER_CENTER_TERMS_AGREEMENT_TYPE: {
        PARTNER: {
          value: 'PARTNER'
        },
        ADVERTISING: {
          value: 'ADVERTISING'
        },
        INDIVIDUAL: {
          value: 'INDIVIDUAL'
        },
        THIRD_PARTY: {
          value: 'THIRD_PARTY'
        }
      },
      MARKETPLACE_TERMS_AGREEMENT_TYPE: {
        MARKETPLACE: {
          value: 'MARKETPLACE'
        },
        INDIVIDUAL: {
          value: 'INDIVIDUAL'
        },
        TO_THIRD_PARTY: {
          value: 'TO_THIRD_PARTY'
        },
        FROM_THIRD_PARTY: {
          value: 'FROM_THIRD_PARTY'
        }
      },
      ERROR_HTTP_STATUS: {
        BAD_PARAMETER: 80400,
        UNAUTHORIZED: 80401,
        FORBIDDEN: 80403,
        NOT_FOUND: 80404,
        INTERNAL_SERVER_ERROR: 80500
      }
    }
    return {
      CODES
    }
  }
}
</script>
